import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthPage = () => {
  const [queryParams, setQueryParams] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const params = {};

    // Cafe24 앱에서 전달되는 파라미터들 파싱
    params.lang = urlParams.get("lang");
    params.mall_id = urlParams.get("mall_id");
    params.nation = urlParams.get("nation");
    params.shop_no = urlParams.get("shop_no");
    params.timestamp = urlParams.get("timestamp");
    params.user_id = urlParams.get("user_id");
    params.user_name = decodeURIComponent(urlParams.get("user_name") || "");
    params.user_type = urlParams.get("user_type");
    params.hmac = urlParams.get("hmac");

    setQueryParams(params);

    // 기본 파라미터가 있으면 자동으로 OAuth 인증 시작
    if (params.mall_id && params.hmac) {
      setTimeout(() => {
        startOAuthAuth(params);
      }, 0);
    }
  }, []);

  const startOAuthAuth = (params) => {
    if (!params.mall_id) {
      setError("몰 ID가 없습니다.");
      return;
    }

    setLoading(true);

    // Cafe24 OAuth 인증 URL 구성
    const clientId = "0zultiuiNpLrW2K6K2uunB";
    //const redirectUri = "https://admin.testbizlingerwateradmin.shop/token/";
    const redirectUri = "https://www.bizlingerwateradmin.co.kr/token/";
    //const redirectUri = "https://57ee6f283538.ngrok-free.app/token/";

    // state에 mall_id와 랜덤값을 포함시켜 전달
    const randomState = Math.random().toString(36).substring(2, 15);
    const stateData = {
      mall_id: params.mall_id,
      random: randomState,
    };
    const state = btoa(JSON.stringify(stateData)); // Base64로 인코딩

    const scope =
      "mall.read_store,mall.read_customer,mall.write_customer,mall.read_notification,mall.write_notification,mall.read_order";

    const authUrl = `https://${params.mall_id}.cafe24api.com/api/v2/oauth/authorize?response_type=code&client_id=${clientId}&state=${state}&redirect_uri=${redirectUri}&scope=${scope}`;

    console.log("OAuth 인증 URL로 이동:", authUrl);

    // OAuth 인증 페이지로 리다이렉트
    window.location.href = authUrl;
  };

  return (
    <div
      style={{
        textAlign: "center",
        padding: "40px",
        minHeight: "100vh",
        backgroundColor: "#f8f9fa",
      }}
    >
      {error && (
        <div
          style={{
            background: "#f8d7da",
            padding: "20px",
            borderRadius: "10px",
            border: "1px solid #f5c6cb",
            color: "#721c24",
            marginTop: "20px",
            maxWidth: "500px",
            margin: "20px auto 0",
          }}
        >
          <h3>❌ 오류 발생</h3>
          <p>{error}</p>
        </div>
      )}
      {/* <h1 style={{ fontSize: "2.5rem", marginBottom: "30px", color: "#333" }}>
        🔐 Cafe24 OAuth 인증
      </h1>

      {!queryParams.mall_id ? (
        <div>
          <h3>⚠️ Cafe24 앱에서 실행해주세요</h3>
          <p>올바른 파라미터가 전달되지 않았습니다.</p>
        </div>
      ) : (
        <div>
          <div
            style={{
              background: "white",
              padding: "30px",
              borderRadius: "15px",
              boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
              maxWidth: "500px",
              margin: "0 auto",
            }}
          >
            <h3>🔄 OAuth 인증을 시작합니다...</h3>
            <div style={{ margin: "20px 0" }}>
              <p>
                <strong>몰 ID:</strong> {queryParams.mall_id}
              </p>
              <p>
                <strong>사용자:</strong> {queryParams.user_name}
              </p>
            </div>

            {loading && (
              <div style={{ margin: "20px 0" }}>
                <div
                  style={{
                    width: "50px",
                    height: "50px",
                    border: "5px solid #f3f3f3",
                    borderTop: "5px solid #007bff",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite",
                    margin: "0 auto",
                  }}
                ></div>
                <p style={{ marginTop: "15px" }}>
                  Cafe24 인증 페이지로 이동 중...
                </p>
              </div>
            )}
          </div>

          {error && (
            <div
              style={{
                background: "#f8d7da",
                padding: "20px",
                borderRadius: "10px",
                border: "1px solid #f5c6cb",
                color: "#721c24",
                marginTop: "20px",
                maxWidth: "500px",
                margin: "20px auto 0",
              }}
            >
              <h3>❌ 오류 발생</h3>
              <p>{error}</p>
            </div>
          )}
        </div>
      )} */}
    </div>
  );
};

export default AuthPage;
